module.exports = __webpack_public_path__ + "media/images/sp/specials/common/clean_ribbon-b95c0bd11c1e8817078081d2b4c6d61f.svg";